<template>
  <v-app id="inspire">
    <main-menu-navigation
      v-if="!isProjectFlow"
      @drawerChange="drawerChange"
      :drawer="drawer"
    ></main-menu-navigation>
    <project-flow-menu-navigation
      v-if="isProjectFlow"
      :drawer="drawer"
    ></project-flow-menu-navigation>
    <main-app-bar
      v-if="!isProjectFlow"
      @drawerChange="drawerChange"
      :drawer="drawer"
    ></main-app-bar>
    <project-flow-app-bar v-if="isProjectFlow"></project-flow-app-bar>
    <v-main class="pb-0">
      <v-container fluid>
        <router-view :key="$route.fullPath" />
      </v-container>
    </v-main>

    <v-footer app>
      <span>&copy; {{ new Date().getFullYear() }} Case3D</span>
      <v-spacer />
      <span>version {{ $store.getters.appVersion }}</span>
    </v-footer>
    <NotificationList
      :notifications="$store.state.NotificationStore.notifications"
    ></NotificationList>
    <dialog-wrapper></dialog-wrapper>
  </v-app>
</template>

<script>
import NotificationList from './components/NotificationList'
import MainMenuNavigation from './components/Navigation/MainMenuNavigation'
import ProjectFlowMenuNavigation from './components/Navigation/ProjectFlowMenuNavigation'
import MainAppBar from './components/AppBar/MainAppBar'
import ProjectFlowAppBar from './components/AppBar/ProjectFlowAppBar'
import DialogWrapper from './components/DialogWrapper'

export default {
  components: {
    NotificationList,
    MainMenuNavigation,
    ProjectFlowMenuNavigation,
    MainAppBar,
    ProjectFlowAppBar,
    DialogWrapper
  },

  props: {
    source: String
  },

  data: () => ({
    drawer: null
  }),

  created() {
    this.$vuetify.theme.dark = true
  },

  methods: {
    backButtonClick: function(e) {
      let path = e.path || e.composedPath()
      path[1].blur()
      this.$router.go(-1)
    },
    drawerChange(drawer) {
      this.drawer = drawer
    }
  },
  computed: {
    currentRootTitle() {
      return this.$route.name
    },
    isHomeRoute() {
      return this.$route.path === '/'
    },
    isProjectFlow() {
      if (
        this.currentRootTitle === 'Explore Project' ||
        this.currentRootTitle === 'Explore Masterplan' ||
        this.currentRootTitle === 'Explore Building' ||
        this.currentRootTitle === 'Explore Apartment' ||
        this.currentRootTitle === 'Explore Apartment Type' ||
        this.currentRootTitle === 'Explore Apartment Orientation' ||
        this.currentRootTitle === 'Explore Poi' ||
        this.currentRootTitle === 'Explore Package'
      ) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>
<style media="screen">
.theme--dark.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  background: #282828 !important;
}
html {
  overflow: auto;
}
</style>
